import styled from "styled-components";
import { BREAKPOINTS } from "../../variables/Breakpoints";
import { setFlex, setPosition } from "../../variables/Position";
import { COLOURS } from "../../variables/Colors";

export const Wrapper = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({ direction: "row" })};
  @media (max-width: ${BREAKPOINTS.md}px) {
    ${setFlex({ direction: "column" })}
  }
`;

export const StackedWrapper = styled(Wrapper)`
  ${props => setFlex({ direction: props.$direction })};
`;

export const SmallHeading = styled.h4`
  font-family: "univers-lt-roman";
  font-size: 0.8rem;
  line-height: 1rem;
  color: ${COLOURS.primary.pink};
  margin: 0 0.5rem;
  font-weight: ${props => (props.$bold ? "bold" : "normal")};
  ${props => props.$indent && "text-indent: 3em"};
  @media (max-width: ${BREAKPOINTS.sm}px) {
    font-size: 0.6rem;
    line-height: 0.7rem;
  }
`;

export const CreditsContainer = styled.div`
  ${props => setFlex({ justify: props.$justify, align: "flex-end" })};
  ${props =>
    props.$wrap === "split" &&
    `
  min-width: 50%;
  height: 100%;
`};
  @media (max-width: ${BREAKPOINTS.md}px) {
    margin-bottom: 2rem;
    margin-top: 0.5rem;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
`;

export const VideoWrapper = styled.div`
  ${setPosition({ position: "relative" })};
  ${props =>
    setFlex({
      justify: props.$wrap === "split" ? "center" : "flex-end",
      align: "center",
      direction: "column",
    })};
  min-width: ${props => (props.$wrap === "split" ? "50%" : "25%")};
  ${props =>
    props.$reverse &&
    `
    @media (max-width: ${BREAKPOINTS.md}px) {
      ${setFlex({ direction: "column-reverse" })};
    }
  `};
`;

export const VideoContainer = styled.div`
  ${setPosition({ position: "absolute" })};
  margin: 0 auto;
  max-width: 100%;
  width: 25vw;
  ${props =>
    props.$wrap !== "split" &&
    `
        left: -25%;
        bottom: -5%;
  `};
  @media (max-width: ${BREAKPOINTS.md}px) {
    ${setPosition({ position: "relative", left: "0", top: "0" })};
    width: 100%;
  }
`;

export const VideoContent = styled.div`
  ${setPosition({ position: "relative" })};
  width: 100%;
  .plyr--full-ui input[type="range"] {
    color: ${COLOURS.primary.black};
  }
  .plyr--video .plyr__control.plyr__tab-focus,
  .plyr--video .plyr__control:hover,
  .plyr--video .plyr__control[aria-expanded="true"] {
    background: ${COLOURS.primary.black};
  }
  ${props =>
    props.hideControls &&
    `
    .plyr__controls {
      display: none;
      }
    `};
  ${props =>
    props.aspectRatio &&
    `
    .plyr__video-embed {
      aspect-ratio: ${props.aspectRatio}!important;
    }
    `};
`;
